// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sanity-document--faqList[data-v-a5b50e46] a{webkit-text-decoration-line:underline;-webkit-text-decoration-line:underline;text-decoration-line:underline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
